var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21.33px",
    height: "24px",
    viewBox: "0 0 21.33 24",
    style: {
      enableBackground: "new 0 0 21.33 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1C4EC1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    className: "st0",
    d: "M4,24c-0.71,0.01-1.39-0.27-1.88-0.78 c-0.51-0.49-0.79-1.17-0.78-1.88V4H0V1.33h6.67V0h8v1.33h6.67V4H20v17.33c0.01,0.71-0.27,1.39-0.78,1.88 c-0.49,0.51-1.17,0.79-1.88,0.78L4,24z M17.33,4H4v17.33h13.33V4z M6.67,18.67h2.67v-12H6.67V18.67z M12,18.67h2.67v-12H12L12,18.67 z M4,4L4,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico_delete.92384dfcc34496019d6a002df426fa30.svg";
export { ForwardRef as ReactComponent };